import { getUnionValues, type UnionRecord } from '../validation'

const mortgageReasonValues: UnionRecord<MortgageReason> = {
  INVALID_MORTGAGE_REASON: null,
  REASON_REMORTGAGE: null,
  REASON_BTL_REMORTGAGE: null,
  REASON_BRIDGING: null,
  REASON_BTL: null,
  REASON_BUSINESS_PROTECTION: null,
  REASON_COMMERCIAL: null,
  REASON_EQUITY_RELEASE: null,
  REASON_FTB: null,
  REASON_FURTHER_ADVANCE: null,
  REASON_GENERAL_INSURANCE: null,
  REASON_HOUSE_MOVE: null,
  REASON_PROTECTION: null,
}

export default getUnionValues(mortgageReasonValues)
